import * as React from "react";
import { Text } from "@fluentui/react-northstar";

export default function TextContent(props) {
  const { content, weight, size, className, disabled, color } = props;
  return (
    <Text
      content={content}
      weight={weight}
      size={size}
      className={className}
      disabled={disabled}
      color={color}
    />
  );
}
